import { createAction, handleActions } from 'redux-actions';
import { Api } from "../../api/api";
import { logout, onForbidden } from '../account/login';
import {
    fetchSubmitForm,
    fetchSubmitFormFailed,
    fetchSubmitFormSuccess,
    resetSubmitFormData
} from '../common/submitForm';
import { hideModal } from '../common/activeModal';
import _ from 'lodash';

//- Actions
export const fetchGetCertifiedAccreditationsFailed = createAction('FETCH_GET_CERTIFIED_ACCREDITATIONS_FAILED');
export const fetchGetCertifiedAccreditationsSuccess = createAction('FETCH_GET_CERTIFIED_ACCREDITATIONS_SUCCESS');
export const fetchGetCertifiedAccreditations = createAction(
    'FETCH_GET_CERTIFIED_ACCREDITATIONS',
    () => Api.getCertifiedAccreditations(),
    () => ({
        apiCall: true,
        onSuccess: fetchGetCertifiedAccreditationsSuccess,
        onFail: fetchGetCertifiedAccreditationsFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onUpdateCertifiedAccreditationSuccess = () => (dispatch) => {
    dispatch(resetSubmitFormData());
    dispatch(hideModal());
    dispatch(fetchGetCertifiedAccreditations());
};
export const fetchUpdateCertifiedAccreditation = (id, data) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onUpdateCertifiedAccreditation(id, data));
};
export const onUpdateCertifiedAccreditation = createAction(
    'FETCH_UPDATE_CERTIFIED_ACCREDITATION',
    (id, data) => Api.updateCertifiedAccreditation(id, data),
    () => ({
        apiCall: true,
        onSuccess: onUpdateCertifiedAccreditationSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onRemoveCertifiedAccreditationSuccess = () => dispatch => {
    dispatch(fetchSubmitFormSuccess());
    dispatch(hideModal());
    dispatch(fetchGetCertifiedAccreditations());
}
export const onRemoveCertifiedAccreditation = createAction(
    'FETCH_REMOVE_CERTIFIED_ACCREDITATION',
    (id) => Api.removeCertifiedAccreditation(id),
    () => ({
        apiCall: true,
        onSuccess: onRemoveCertifiedAccreditationSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const removeCertificateAccreditation = id => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onRemoveCertifiedAccreditation(id));
}

//- State
const initialState = {
    fetching: false,
    data: null,
    error: null
};

//- Reducers
export default handleActions({
    FETCH_GET_CERTIFIED_ACCREDITATIONS: (state) => {
        return { ...state, error: null, fetching: true };
    },
    FETCH_GET_CERTIFIED_ACCREDITATIONS_FAILED: (state, action) => {
        return { ...state, data: null, error: action.payload, fetching: false };
    },
    FETCH_GET_CERTIFIED_ACCREDITATIONS_SUCCESS: (state, action) => {
        return { ...state, data: action.payload, error: null, fetching: false };
    }
}, initialState);

//- Selectors
export const getCertifiedAccreditations = state => state.certifiedAccreditations;

export const loadingCertifiedAccreditations = state => getCertifiedAccreditations(state).fetching;

export const getCertifiedAccreditationsData = state => {
    let data = getCertifiedAccreditations(state).data;

    if (_.isNil(data)) {
        return null;
    }

    return _.map(data, (accreditation) => ({
        id: accreditation.id,
        titleOriginal: accreditation.accreditationData.titles.original,
        titleEn: accreditation.accreditationData.titles.en,
        additionalTitles: {
            ..._.pickBy((accreditation.accreditationData.titles), (value, key) => {
                return key !== 'en' && key !== 'original';
            })
        },
        dateIssued: accreditation.accreditationData.issuedAt,
        issuedByName: accreditation.organization.name,
        issuedByCountry: accreditation.organization.address.countryCode,
        level: accreditation.accreditationData.level,
        expose: accreditation.expose
    }));
};

export const getCertifiedAccreditationDataById = (state, id) => {
    if (_.isNil(getCertifiedAccreditationsData(state))) {
        return null;
    }

    return getCertifiedAccreditationsData(state).find(elem => {
        return elem.id === id;
    })
}



// WEBPACK FOOTER //
// ./src/reducers/applicantAccreditations/certifiedAccreditations.js